import {default as Main} from './Main';

export default {
  Main,
};
